import { render, staticRenderFns } from "./NoDataMessage.vue?vue&type=template&id=07e2b75f&scoped=true&"
import script from "./NoDataMessage.vue?vue&type=script&lang=js&"
export * from "./NoDataMessage.vue?vue&type=script&lang=js&"
import style0 from "./NoDataMessage.vue?vue&type=style&index=0&id=07e2b75f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e2b75f",
  null
  
)

export default component.exports